import { useEffect } from 'react';

// ページごとのタイトル・説明文・正式なURL（canonical）・共有したときの見え方（OGP）・検索に載せるか（robots）を設定する。
// どのページも必ず呼ぶ。呼ばないページでは、前に開いたページの値が残る。
//
// ビルド後の scripts/prerender.js は、各ページを開いた状態の <head> からこれらのタグを読み、
// そのページの最初の HTML（build/<パス>/index.html）に書き込む。だから最初の HTML の値と、
// 画面が開いたあとにここで設定する値は同じになる（canonical を JavaScript で別の URL に変えない）。
export const SITE = 'https://salt-2.com';

// 指定がないときの値（public/index.html の初期値と同じにしておく）
const DEFAULTS = {
  // 共有したときの画像（1200×630。トップの冒頭と同じ見た目。2026-10-18 に作った。以前の S3 の住所の画像は無く、共有画像が出ていなかった）
  image: 'https://salt-2.com/ogp.jpg',
  siteName: '株式会社SALT2',
  themeColor: '#F6F4EF',
  robots: 'index, follow',
};

// value が null ならタグを外し、undefined なら触らない。タグが無ければ作る
const setTag = (tag, key, name, attr, value) => {
  if (value === undefined) return;
  let el = document.head.querySelector(`${tag}[${key}="${name}"]`);
  if (value === null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const absolute = (url) => (url.startsWith('/') ? `${SITE}${url}` : url);

/**
 * path: 正式な URL のパス（例: '/enablement'）。null なら canonical を置かない（404 など、検索に載せないページ）。
 * ogTitle・ogDescription: 共有したときの名前・説明（省略時は title・description）。
 * image: 共有したときの画像（'/img/...' はサイトの URL にする）。siteName・themeColor も同様に上書きできる。
 * robots: 'noindex' など。省略時は index, follow。
 */
export default function usePageMeta({
  title,
  description,
  path,
  ogTitle,
  ogDescription,
  image,
  siteName,
  themeColor,
  robots,
}) {
  useEffect(() => {
    const url = path == null ? null : `${SITE}${path}`;
    const img = absolute(image || DEFAULTS.image);
    if (title) document.title = title;
    setTag('meta', 'name', 'description', 'content', description);
    setTag('link', 'rel', 'canonical', 'href', url);
    setTag('meta', 'name', 'robots', 'content', robots || DEFAULTS.robots);
    setTag('meta', 'name', 'theme-color', 'content', themeColor || DEFAULTS.themeColor);
    setTag('meta', 'property', 'og:title', 'content', ogTitle || title);
    setTag('meta', 'property', 'og:description', 'content', ogDescription || description);
    setTag('meta', 'property', 'og:url', 'content', url);
    setTag('meta', 'property', 'og:image', 'content', img);
    setTag('meta', 'property', 'og:site_name', 'content', siteName || DEFAULTS.siteName);
    setTag('meta', 'name', 'twitter:title', 'content', ogTitle || title);
    setTag('meta', 'name', 'twitter:description', 'content', ogDescription || description);
    setTag('meta', 'name', 'twitter:image', 'content', img);
  }, [title, description, path, ogTitle, ogDescription, image, siteName, themeColor, robots]);
}
